export enum DeprecatedOrganizationTypeEnum {
  CARE_DEPARTMENT = 'CARE_DEPARTMENT',
  CARE_CENTER = 'CARE_CENTER',
  CARE_GROUP = 'CARE_GROUP',
  CARE_DIVISION = 'CARE_DIVISION',
  CALL_DEPARTMENT = 'CALL_DEPARTMENT',
  BILLING_DEPARTMENT = 'BILLING_DEPARTMENT',
  ROOT = 'ROOT',
}
